// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__29CMD","signatureBlock":"Footer_signatureBlock__1-9Hx","signature":"Footer_signature__C3VnB"};